import { render, staticRenderFns } from "./SpeakersSettings.vue?vue&type=template&id=ab1f3f48&scoped=true&lang=pug"
import script from "./SpeakersSettings.vue?vue&type=script&lang=js"
export * from "./SpeakersSettings.vue?vue&type=script&lang=js"
import style0 from "./SpeakersSettings.vue?vue&type=style&index=0&id=ab1f3f48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1f3f48",
  null
  
)

export default component.exports